import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import urlHandler from '../../utils/urlHandler';
import validation from '../../utils/validation';
import settings from '../../utils/settings';
import ReactModal from 'react-modal';

class SendingProgress extends Component {
    render() {
        return (
            <div className="feedback-sending">
                <span className="fa fa-circle-o-notch fa-spin"></span>&nbsp;&nbsp;Sending ...
            </div>
        );
    }
}

class ScoreSlider extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        e.preventDefault();
        var value = parseFloat(e.currentTarget.value, 10);
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    render() {
        return (
            <div>
                <label className='form-label-inline feedback-form-label'>Score:  </label>
                <label className='form-label-inline-value feedback-form-label'>{this.props.value.toFixed(2)}</label>
                <input type="range"
                    className="score-slider"
                    min={ -1.00 }
                    max={ 1.00 }
                    step={ 0.01 }
                    value={ this.props.value }
                    onChange={ this.onChange } />
                <div className="score-gradient">
                </div>
            </div>
        );        
    }
}

class EntityFeedbackDialog extends Component {
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onChangeScore = this.onChangeScore.bind(this);
        this.onChangeType = this.onChangeType.bind(this);
        this.reset = this.reset.bind(this);

        this.state = {
            error: '',
            sending: false,
            modalOpen: false,
            entity: '',
            assigned_type: '',
            feedback_type: '',
            location: '',
            assigned_sentiment: null,
            feedback_sentiment: null,
            disambig: ''
        };
    };

    conmponentDidMount() {
        ReactModal.setAppElement('#rm_EntityFeedbackDialog');
    }

    reset() {
        this.setState(
            { 
                error: '', 
                sending: false
            });
    };

    close() {
        this.setState({
            sending: false,
            modalOpen: false
        })
    };

    open(segment) {
        this.reset();
        if (segment.entities && segment.entities.length > 0) {

            // See if we have a type
            var type = segment.entities[0].type;

            // See if we have sentiment
            var sentiment = null;
            if (segment.entities[0].mention && segment.entities[0].mention.sentiment) {
                sentiment = segment.entities[0].mention.sentiment;
            }       

            // See if we have disambig info
            var disambig = '';
            if (segment.entities[0].disambiguationResults && segment.entities[0].disambiguationResults.length > 0) {
                var disambigObj = segment.entities[0].disambiguationResults[0];
                disambig = disambigObj.label;
                if (disambigObj.attributes && disambigObj.attributes.urls && disambigObj.attributes.urls.length > 0) {
                    disambig += ' (' + disambigObj.attributes.urls[0] + ')';
                }
            }

            // Open the dialog and set the state
            if (sentiment) {
                this.setState({
                    modalOpen: true,
                    entity: segment.text,
                    location: segment.anchor.start + '-' + segment.anchor.stop,
                    assigned_sentiment: Object.assign({}, {
                        class: sentiment.class,
                        classConfidence: sentiment.classConfidence || 0.0,
                        score: sentiment.score || 0.0
                    }),
                    feedback_sentiment: {
                        class: sentiment.class,
                        classConfidence: sentiment.classConfidence || 0.0,
                        score: sentiment.score || 0.0
                    },
                    sentiment_model: settings.getValue('sentimentModel', window._sentimentModel),
                    assigned_type: type,
                    feedback_type: type,
                    disambig
                })
            } else {
                this.setState({
                    modalOpen: true,
                    entity: segment.text,
                    location: segment.anchor.start + '-' + segment.anchor.stop,
                    assigned_type: type,
                    feedback_type: type,
                    assigned_sentiment: null,
                    feedback_sentiment: null,
                    sentiment_model: settings.getValue('sentimentModel', window._sentimentModel),
                    disambig
                })
            }
        } else {
            this.setState({
                modalOpen: true,
                entity: segment.text,
                location: segment.anchor.start + '-' + segment.anchor.stop
            })           
        }
    };

    handleSubmit() {
        this.setState({sending: true});

        urlHandler.submitEntityFeedback(
            {
                comment: this.refs.comment.value,
                entity: this.state.entity,
                location: this.state.location,
                assigned_sentiment: (this.state.assigned_sentiment) ? JSON.stringify(this.state.assigned_sentiment) : null,
                feedback_sentiment: (this.state.feedback_sentiment) ? JSON.stringify(this.state.feedback_sentiment) : null,
                sentiment_model: this.state.sentiment_model,
                assigned_type: this.state.assigned_type || '',
                feedback_type: this.state.feedback_type || '',
                content: this.props.text,
                results: this.props.results
            }
        ).then((response) => {
            console.log(response.data);
            this.close();
        }).catch((err) => {
            console.log(err.response.data);
            this.setState({
                sending: false,
                error: err.response.data
            })
        });
    };

    onChangeScore(val) {
        let classVal = 'neutral';
        if (val >= -1.0 && val < -0.25) {
            classVal = 'negative';
        } else if (val <= 1.0 && val > 0.25) {
            classVal = 'positive';
        }
        this.setState({
            feedback_sentiment: {
                class: classVal,
                classConfidence: this.state.feedback_sentiment.classConfidence || 0.0,
                score: val
            }
        })
    }

    onChangeType(e) {
        this.setState({
            feedback_type: e.target.value
        })
    }

    render() {

        const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '35%',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                transform   : 'translate(-50%, -35%)',
                maxWidth    : '600px',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }

        const types = [
            'ACRONYM',
            'GEO',
            'ORGANIZATION',
            'ORGANIZATION/COMPANY',
            'ORGANIZATION/CRIMINAL',
            'ORGANIZATION/EDUCATIONAL',
            'ORGANIZATION/GOVERNMENT',
            'ORGANIZATION/PERFORMING',
            'ORGANIZATION/SPORTS',
            'ORGANIZATION/NEWS',
            'ORGANIZATION/SOCIALMEDIA',
            'ORGANIZATION/COMPANY/TICKER',
            'ORGANIZATION/FUND',
            'ORGANIZATION/TRUST',
            'THING',
            'THING/CHEMICAL',
            'THING/MEDICAL',
            'THING/FINANCIAL',
            'THING/LEGAL',
            'THING/EVENT',
            'THING/FACILITY',
            'THING/PRODUCT',
            'THING/TECHNOLOGY',
            'PERSON',
            'POSITION',
            'DATETIME',
            'DATETIME_RANGE',
            'EMAIL',
            'IPV4',
            'MEASUREMENT',
            'MONEY',
            'NATIONALITY',
            'ETHNICITY',
            'LANGUAGE',
            'PHONE',
            'TWITTER',
            'URI'
        ]

        return (
           <div id="rm_EntityFeedbackDialog">
                <ReactModal ref="feedbackId" 
                    isOpen={this.state.modalOpen}
                    contentLabel="Feedback Form"
                    onRequestClose={this.close} 
                    style={styles}
                    closeTimeoutMS={1000}>
                    <div className="feedback-dialog">
                        <div className="feedback-header">
                            Entity and Sentiment Feedback
                        </div>
                        <div className="feedback-description">
                            <span className='fa fa-comments-o feedback-icon'>&nbsp;</span>
                            Notice a problem with extraction, disambiguation or sentiment assignment? Please provide any information so we can enhance our product.    
                        </div>
                        <div className="feedback-content">
                            <div className="feedback-form">
                                <div className='form-field-wrapper'>
                                    <span>
                                        <label className='form-label-inline feedback-form-label'>Entity:  </label>
                                        <label className='form-label-inline-value feedback-form-label'>{this.state.entity}</label>
                                    </span>
                                    <br/>
                                    <span>
                                        <label className='form-label-inline feedback-form-label'>Document Location:  </label>
                                        <label className='form-label-inline-value feedback-form-label'>{this.state.location}</label>
                                    </span>
                                </div>
                                <table className="form-field-table">
                                    <tbody>
                                        {(this.state.assigned_type.length > 0) &&
                                            <tr>
                                                <td className="form-field-wrapper text-field form-field-left">
                                                    <label className='form-label feedback-form-label'>Assigned Type:</label>
                                                    <div className="form-field-sentiment-wrapper">
                                                        <select className="form-field" onChange={this.onChangeType} defaultValue={this.state.assigned_type}>
                                                        {types.map((type) => {
                                                            return <option key={type} value={type}>{type}</option>
                                                        })
                                                        }
                                                        </select>
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                        {(this.state.disambig.length > 0) &&
                                            <tr>
                                                <td className="form-field-wrapper form-field-left" style={{paddingBottom:'10px'}}>
                                                    <label className='form-label feedback-form-label'>Disambiguated To:</label>
                                                    <label className="feedback-form-label"  style={{paddingLeft:'10px'}}>{this.state.disambig}</label>
                                                </td>
                                            </tr>
                                        }
                                        {this.state.feedback_sentiment &&
                                            <tr>
                                                <td className="form-field-wrapper form-field-left">
                                                    <label className='form-label feedback-form-label'>Assigned Sentiment:</label>
                                                    <div className="form-field-sentiment-wrapper">
                                                        <span>
                                                            <label className='form-label-inline feedback-form-label'>Class:  </label>
                                                            <label className='form-label-inline-value feedback-form-label'>{this.state.feedback_sentiment.class}</label>
                                                        </span>
                                                        <br/>
                                                        <span>
                                                            <label className='form-label-inline feedback-form-label'>Class Confidence:  </label>
                                                            <label className='form-label-inline-value feedback-form-label'>{this.state.feedback_sentiment.classConfidence}</label>
                                                        </span>
                                                        <span>
                                                            <ScoreSlider value={this.state.feedback_sentiment.score} onChange={this.onChangeScore}/>
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                        <tr>
                                            <td className="form-field-wrapper form-field-right">
                                                <label htmlFor='issueField' className='form-label feedback-form-label'>Comments:</label>
                                                <textarea className='form-field feedback-textarea feedback-form-field'
                                                        name='comment'
                                                        id='commentField'
                                                        ref='comment'
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br/>
                                <span className="feedback-error-msg">{this.state.error}</span>
                            </div>
                        </div>
                        <div className="feedback-footer">
                            {this.state.sending ? <SendingProgress /> : null}
                            <button type="button" className="feedback-default-button" onClick={this.handleSubmit}>Submit Feedback</button>
                            <button type="button" className="feedback-default-button" onClick={this.close}>Cancel</button>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    };
}

export default EntityFeedbackDialog;


